import { Modelizr } from 'modelizr'; 
// Apollo client
import { clientURI } from './clientURI';

const _models = {};
const config = require('../config');

export let modelizr = null; 

// export const fetchApi = (config) => {

//   console.log(config.body);


// }

export function buildModels(...args) {
  args.forEach(m => Object.assign(_models, {[m.prototype.constructor.name]: m } ));

  modelizr = new Modelizr({
    models: Object.values(_models).reduce((acc, curr) => Object.assign(acc, curr.schema), {}), 
    // api: fetchApi, 
    config: {
      endpoint: `${config.backend.uri}/graphql`,
    }
  });

  Object.entries(_models).forEach(([key, val]) => {
    Object.assign(val, { gql: Object.assign(modelizr, {client: clientURI}) });
  });

  return modelizr; 
}

export function getModelizr() {
  return modelizr; 
}

export function getModels(model) {
  return modelizr.models; 
}

export function getModel(model) {
  return modelizr.models[model.constructor.name]; 
}



// WEBPACK FOOTER //
// ./src/libraries/graphql.js